import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import Loader from "react-loader";
import {fetchedPage, loadPage} from "../../actions/page";
import HeroImage from "../elements/HeroImage";
import RegionSelect from "../elements/RegionSelect";
import Title from "../elements/Title";
import BlockLoop from "../elements/BlockLoop";
import TopBar from "../layout/TopBar";
import TopNavigation from "../navigation/TopNavigation";
import Footer from "../layout/Footer";
import SideBar from "../navigation/SideBar";

class HomePage extends React.Component {

    submit = data => {
        console.log(data);
    }
    componentWillUnmount() {
        this.props.loadPage()
    }

    componentWillMount() {
        this.props.fetchedPage('/api' + this.props.location.pathname).then();
    }

    render() {
        const {page, modal, navigation, loaded} = this.props;
        return (
          <Loader loaded={loaded}>
          <div className={modal.activeClass === false ? "rob" : "rob rob__blur"}>
              <TopBar/>
              <TopNavigation/>
              <SideBar navigation={navigation}/>
              <div className={"transition-item"}>
                  <HeroImage {...page.heroImage}  />
                  <Title introTitle={page.introTitle}/>
                  <BlockLoop/>
                  <RegionSelect title='Find help in your Region'/>
              </div>
              <Footer/>
          </div>
          </Loader>

        )
    };

}

HomePage.propTypes = {
    fetchedPage: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        page: state.page,
        modal: state.modal,
        loaded: state.loaded.loaded,
        navigation: state.navigation
    };
}

export default connect(mapStateToProps, {fetchedPage, loadPage})(HomePage);




// WEBPACK FOOTER //
// ./src/components/pages/HomePage.js